import _ from 'underscore';
import type { HostedAntiForgeryTokenFetcher } from './types';

const antiForgeryTokenKey = '__RequestVerificationToken';
let hostedAntiForgeryTokenFetcher: HostedAntiForgeryTokenFetcher | null | undefined;

export function setHostedAntiForgeryTokenFetcher(fetcher: HostedAntiForgeryTokenFetcher | null) {
  hostedAntiForgeryTokenFetcher = fetcher;
}

export function getAntiForgeryToken() {
  const hostedAntiForgeryToken = _.isFunction(hostedAntiForgeryTokenFetcher)
    ? hostedAntiForgeryTokenFetcher()
    : null;

  if (hostedAntiForgeryToken) {
    return hostedAntiForgeryToken;
  }

  const antiForgeryTokenInput = document.querySelector<HTMLInputElement>(`input[name="${antiForgeryTokenKey}"]`);
  return antiForgeryTokenInput && antiForgeryTokenInput.value;
}

export { antiForgeryTokenKey };
